import {useField, useSubmitCount} from 'vee-validate';
import {watch, type Ref} from 'vue';
import {isObject} from 'lodash-es';

type AcceptableTypesT = undefined | null | string | number | boolean | Object;

type ReactiveObj<T> = {
    [P in keyof T]: Ref<T[P]>;
};

export function useFieldModelCustom<T extends Record<string, AcceptableTypesT>>(
    keys: keyof T | (keyof T)[], // 참조할 state명과 타입. 여러개 참조할때에는 배열안에 나열해서 전달
    options?: {
        // useFieldModelCustom의 option
        afterSubmit?: boolean; // submit 후 validate 진행할지 여부
    },
) {
    if (!Array.isArray(keys)) {
        keys = [keys];
    }

    const submitCount = useSubmitCount(); // submit 진행여부 체크용

    const reactiveObj = {} as ReactiveObj<T>; // return 용

    keys.map((key) => {
        const fieldContext = useField<T[keyof T]>(key as string, undefined, {
            validateOnValueUpdate: false,
        });

        watch(fieldContext.value, (newVal, oldVal) => {
            if (isObject(newVal) || isObject(oldVal)) {
                throw new Error(
                    'useFieldModelCustom: array, object를 이용해 사용할 수 없습니다.',
                );
            }

            if (options?.afterSubmit) {
                if (submitCount.value > 0) {
                    fieldContext.handleChange(fieldContext.value.value);
                } else {
                    fieldContext.setValue(fieldContext.value.value);
                }
            } else {
                fieldContext.handleChange(fieldContext.value.value);
            }
        });
        reactiveObj[key] = fieldContext.value;
    });

    return reactiveObj;
}
